import styles from "./PlanDiscountNotice.module.scss";

export function PlanDiscountNotice(): React.ReactNode {
  return (
    <div className={styles.planDiscountNotice}>
      3ヶ月割引プランのご加入中は、ポイントパックのご購入はできかねます。プラン終了後にご利用ください。
    </div>
  );
}
